// ===================================================
// File: src/hooks/useInfoAlert.js
// ===================================================
import { useCallback, useState } from 'react';

const useInfoAlert = () => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
    icon: '',
    buttonText: 'OK',
    cancelText: '',
    onConfirm: null,
    onCancel: null,
  });

  const showAlert = useCallback((config) => {
    setAlertState({
      isOpen: true,
      title: config.title || 'Information',
      message: config.message || 'This is an information alert.',
      type: config.type || 'info',
      icon: config.icon || '',
      buttonText: config.buttonText || 'OK',
      cancelText: config.cancelText || '',
      onConfirm: config.onConfirm || null,
      onCancel: config.onCancel || null,
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlertState((prev) => ({
      ...prev,
      isOpen: false,
      onConfirm: null,
      onCancel: null,
    }));
  }, []);

  return { alertState, showAlert, hideAlert };
};

export default useInfoAlert;